import { render, staticRenderFns } from "./ProjectOutcomes.vue?vue&type=template&id=1540bc0e&scoped=true"
import script from "./ProjectOutcomes.vue?vue&type=script&lang=js"
export * from "./ProjectOutcomes.vue?vue&type=script&lang=js"
import style0 from "./ProjectOutcomes.vue?vue&type=style&index=0&id=1540bc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540bc0e",
  null
  
)

export default component.exports